import React from 'react';
import clx from 'classnames';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/InstallableAppsIndex';
import { routes } from 'client/lib/routes';

import styles from './Footer.module.scss';

const t = i18n(keyset);

export const Footer = () => {
    return (
        <footer className={styles.footer}>
            <a
                className={clx(styles.footer__element, styles.footer__element_link)}
                href={routes.documentation.index}
                rel="noopener noreferrer"
            >
                {t('docs')}
            </a>
            <a
                className={clx(styles.footer__element, styles.footer__element_link)}
                href={routes.documentation.aliceSkills.feedback}
                rel="noopener noreferrer"
            >
                {t('feedback')}
            </a>
            <span className={clx(styles.footer__element, styles.footer__element_text)}>{t('yandex-copyright')}</span>
        </footer>
    );
};
